export default __webpack_public_path__ + "static/media/logo_green.466ca7ae.svg";